import Vuex from 'vuex'

import vue from 'vue'
import surveillances from '@/store/surveillances'
import user from '@/store/user'
import sheet from '@/sui/store/sheet'
import denominators from '@/sui/store/denominators'
import toolsUsage from '@/sui/store/toolsUsage'
import results from '@/sui/store/results'
import infections from '@/store/infections'
import cloud from '@/sui/store/cloud'

import password from '@/sui/store/password'

vue.use(Vuex)

const debug = process.env.VUE_APP_SPIADI_DEBUG === '1'

export default new Vuex.Store({
  modules: {
    surveillances,
    user,
    password,
    sheet,
    denominators,
    toolsUsage,
    infections,
    cloud,
    results: results(true)
  },
  strict: debug
})
